import { userInfoType, menuType } from '../types';

export const authorizeMenu = (info: userInfoType, menu_id: number): boolean => {
  const { menu = [] }: { menu?: menuType[] } = info || {};

  return menu.length > 0 && menu.findIndex((module: any) => module.menu.menu_id === menu_id) > -1;
};
